import axiosInstance from '@utils/axios';
import { fetchRequest, fetchSuccess, fetchFailure } from '@actions/appActions';
import { checkStatusCode } from '@utils/checkStatusCode';

/**
 * Fetches list of all indicator template groups.
 * GET /config/indicator-template-group
 */
export const fetchIndicatorTemplateGroupList = () => (dispatch) => {
  dispatch(fetchRequest());
  return axiosInstance
    .get('/config/indicator-template-group')
    .then((res) => {
      dispatch(fetchSuccess());
      return res.data;
    })
    .catch((err) => {
      dispatch(
        fetchFailure({ type: 'error', message: checkStatusCode(err), isActive: true }),
      );
      throw err;
    });
};

/**
 * Fetches a single indicator template group by ID.
 * GET /config/indicator-template-group/{id}
 */
export const fetchIndicatorTemplateGroup = (id) => (dispatch) => {
  dispatch(fetchRequest());
  return axiosInstance
    .get(`/config/indicator-template-group/${id}`)
    .then((res) => {
      dispatch(fetchSuccess());
      return res.data;
    })
    .catch((err) => {
      dispatch(
        fetchFailure({ type: 'error', message: checkStatusCode(err), isActive: true }),
      );
      throw err;
    });
};

/**
 * Creates a new indicator template group.
 * POST /config/indicator-template-group
 * @param {Object} data - Group data to create
 */
export const createIndicatorTemplateGroup = (data) => (dispatch) => {
  dispatch(fetchRequest());
  return axiosInstance
    .post('/config/indicator-template-group', data)
    .then((res) => {
      dispatch(fetchSuccess({ type: 'success', message: res.data.status, isActive: true }));
      return res.data;
    })
    .catch((err) => {
      dispatch(
        fetchFailure({ type: 'error', message: checkStatusCode(err), isActive: true }),
      );
      throw err;
    });
};

/**
 * Updates an existing indicator template group.
 * PUT /config/indicator-template-group/{id}
 * @param {number|string} id - Group ID
 * @param {Object} data - Updated group data
 */
export const updateIndicatorTemplateGroup = (id, data) => (dispatch) => {
  dispatch(fetchRequest());
  return axiosInstance
    .put(`/config/indicator-template-group/${id}`, data)
    .then((res) => {
      dispatch(fetchSuccess({ type: 'success', message: res.data.status, isActive: true }));
      return res.data;
    })
    .catch((err) => {
      dispatch(
        fetchFailure({ type: 'error', message: checkStatusCode(err), isActive: true }),
      );
      throw err;
    });
};

/**
 * Deletes an indicator template group by ID.
 * DELETE /config/indicator-template-group/{id}
 * @param {number|string} id - Group ID
 */
export const deleteIndicatorTemplateGroup = (id) => (dispatch) => {
  dispatch(fetchRequest());
  return axiosInstance
    .delete(`/config/indicator-template-group/${id}`)
    .then((res) => {
      dispatch(fetchSuccess({ type: 'success', message: res.data.status, isActive: true }));
      return res.data;
    })
    .catch((err) => {
      dispatch(
        fetchFailure({ type: 'error', message: checkStatusCode(err), isActive: true }),
      );
      throw err;
    });
};